import { apiFetch, buildApiError } from './httpClient';

function parseEventType(lines, line) {
  const prevLine = lines[lines.indexOf(line) - 1];
  return prevLine && prevLine.startsWith('event:')
    ? prevLine.slice(6).trim()
    : 'message';
}

async function readSse(response, callbacks = {}) {
  const { onTextDelta, onEmbedComplete, onDone, onError, onOverageWarning } = callbacks;
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';

    for (const line of lines) {
      if (!line.trim() || !line.startsWith('data:')) continue;
      const dataStr = line.slice(5).trim();
      try {
        const data = JSON.parse(dataStr);
        const eventType = parseEventType(lines, line);
        if (eventType === 'text_delta') onTextDelta?.(data.content || '');
        if (eventType === 'embed_complete' && data.embed) onEmbedComplete?.(data.embed);
        if (eventType === 'overage_warning') onOverageWarning?.(data);
        if (eventType === 'done') onDone?.(data);
        if (eventType === 'error') onError?.(new Error(data.message || 'Unknown dashboard stream error'));
      } catch (error) {
        console.error('Failed to parse dashboard SSE data:', error, dataStr);
      }
    }
  }
}

export const dashboardService = {
  async getSummary(range = '30d') {
    const response = await apiFetch(`/api/dashboard/summary?range=${encodeURIComponent(range)}`);
    const result = await response.json();

    if (!response.ok || !result.ok) {
      const error = new Error(result?.error || 'Failed to load dashboard');
      error.status = response.status;
      error.detail = result?.error || result;
      throw error;
    }

    return result.data;
  },

  async streamDashboardAsk({ message, range = '30d', history = [] }, callbacks = {}) {
    const apiHistory = history.map((item) => ({
      role: item.role,
      content: item.content,
    }));
    const response = await apiFetch('/api/dashboard/ask_stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, range, history: apiHistory }),
    });

    if (!response.ok) {
      throw await buildApiError(response, 'Dashboard stream failed');
    }

    await readSse(response, callbacks);
  },
};
